import React from 'react';
import { IConcreteJobConfirmationPopupProperties, IJobResultComponentProps } from '../../jobs-monitor-host.viewmodel';
import { IAssignRoomsJobDetails, IAssignRoomsJobResult } from '../../../../api/jobs.dao';
import './assign-rooms.scss';

const assignRoomsJobProperties: IConcreteJobConfirmationPopupProperties<IJobResultComponentProps<IAssignRoomsJobDetails, IAssignRoomsJobResult>> = {
    reviewCompletedJobButtonText: 'Ok',
    reviewFailedJobButtonText: 'Ok',
    completeComponent: (props: IJobResultComponentProps<IAssignRoomsJobDetails, IAssignRoomsJobResult>) => {
        return (
            <div className='assign-rooms-result-alert'>
                <div>{props.result.assignedRooms} meetings have been assigned to a Room</div>
                <div>{props.result.couldNotBeAssignedRooms} meetings could not be assigned as there is no matching Room.</div>
            </div>
        );
    },
    failedComponent: (props: IJobResultComponentProps<IAssignRoomsJobDetails, IAssignRoomsJobResult>) => {
        return <>Rooms assigment for {props.jobDetails.eventName} has failed</>;
    }
};

export { assignRoomsJobProperties };
